import React from 'react';
import { map } from 'lodash';
import { Input, Label } from 'reactstrap';

const VehicleSearchComponent = ({ labelsHandler, secondHandler, closeReasons }) => {
  const { secondData, setSecondData } = secondHandler;
  const { labels, setLabels } = labelsHandler;
  return (
    <div className="crm-modal-form-group" >
      <div className="crm-modal-input-group">
        <Label>Motivo de cierre</Label>
        <Input
          className='crm-modal-input-text'
          type='select'
          value={secondData.closeReason}
          onChange={(e) => {
            setSecondData({
              ...secondData,
              closeReason: e.target.value,
              comment: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text
            });
            setLabels({ ...labels, closeReason: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text });
          }}
          required
        >
          <option key='select' value=''>
            Seleccione
          </option>
          {map(closeReasons.data, (e) => (
            <option key={e._id} value={e._id}>
              {e.name}
            </option>
          ))}
        </Input>
      </div>
    </div>
  )
}

export default VehicleSearchComponent;